module.exports = __webpack_public_path__ + "GLD-MF-IM-Black.jpg?ae629dad2599fba01305ede2ada998d8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GLD-MF-IM-Black.jpg
// module id = 86
// module chunks = 0